import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../utils/contants";

export const PlannerStyled = styled.div`
  .info-container {
    background-color: white;
    position: sticky;
    top: 56px;
    z-index: 98;
    padding: 0 36px;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1),
      0px 1px 2px 0px rgba(0, 0, 0, 0.06);
  }

  .flex {
    display: flex;
    gap: 8px;
  }

  .flex-24 {
    display: flex;
    gap: 24px;
  }

  .planner-container {
    display: flex;
    gap: 16px;
    position: relative;
  }

  .main-grid {
    display: grid;
    grid-template-columns: 3fr 2fr;
    padding: 12px 36px 36px;
  }

  .main-grid-override {
    display: grid;
    grid-template-columns: 0fr 1fr !important;
    padding: 0 36px !important;
  }

  .milestone-box {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px 36px 36px 0;
    position: relative; /* Ensure it remains beneath the drawer */
    z-index: 1;
    padding-left: ${(props) =>
      props.plannerType === "Materials" ? "36px" : "0"};
  }

  .divider {
    margin-top: 20px;
    padding-right: 20px;
    width: 96%;
    margin: 0px 20px;
    .div-style {
      width: 100%;
      background: ${COLOUR_CONSTANT.theme.purple.medium};
    }
  }
`;
